const unknown = 'unknown'
const post = 'post'
const contribution = 'contribution'
const like = 'like'
const request = 'request'
const invite = 'invite'
const amp = 'amp'
const mention = 'mention'
const post_scheduled = 'post_scheduled'
const newsletter = 'newsletter'
const newsletter_scheduled = 'newsletter_scheduled'
const question = 'question'
const request_accepted = 'request_accepted'
const invite_accepted = 'invite_accepted'
const submission = 'submission'
const submission_rejected = 'submission_rejected'
const new_member = 'new_member'
const new_hub = 'new_hub'
const post_digest = 'post_digest'

export const Types = {
  unknown,
  post,
  contribution,
  like,
  request,
  invite,
  amp,
  mention,
  post_scheduled,
  newsletter,
  newsletter_scheduled,
  question,
  request_accepted,
  invite_accepted,
  submission,
  submission_rejected,
  new_member,
  new_hub,
  post_digest,
}
